module.exports = __webpack_public_path__ + "static/media/Empaque_comida_preparada-Barana.81a3a12d.jpg";